import { render, staticRenderFns } from "./backoffReasonSetting.vue?vue&type=template&id=61dabf30&scoped=true&"
import script from "./backoffReasonSetting.vue?vue&type=script&lang=js&"
export * from "./backoffReasonSetting.vue?vue&type=script&lang=js&"
import style0 from "./backoffReasonSetting.vue?vue&type=style&index=0&id=61dabf30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dabf30",
  null
  
)

export default component.exports